import _ from 'underscore';
import { parseSync } from '@bingads-webui/safe-json';

const headlinePositionKey = ['Headline1', 'Headline2', 'Headline3', 'None'];
const descriptionPositionKey = ['Description1', 'Description2', 'None'];

function endWithPeriod(text) {
  if ('.?!'.indexOf(text.slice(-1)) === -1) {
    return `${text}.`;
  }

  return text;
}

export function combineDescriptions(textPart1, textPart2) {
  if (_.isEmpty(textPart1) && _.isEmpty(textPart2)) {
    return '';
  }

  if (_.isEmpty(textPart1)) {
    return endWithPeriod(textPart2);
  }

  if (_.isEmpty(textPart2)) {
    return endWithPeriod(textPart1);
  }

  let combinedText;

  if ('.?!'.indexOf(textPart1.slice(-1)) > -1) {
    combinedText = `${textPart1} ${textPart2}`;
  } else {
    combinedText = `${textPart1}. ${textPart2}`;
  }

  return endWithPeriod(combinedText);
}

export function combineDescriptionArray(desArray) {
  if (!_.isArray(desArray)) {
    return '';
  }

  if (desArray.length < 2) {
    return desArray[0];
  }

  return combineDescriptions(desArray[0], desArray[1]);
}

export function getPreviewList(data, positionKey) {
  if (!_.isArray(data)) {
    return [];
  }

  const list = _.mapObject(_.invert(positionKey), () => []);
  _.each(data, (item) => {
    if (!_.isEmpty(_.result(item, 'Text')) && _.has(list, item.PinnedField)) {
      list[item.PinnedField].push(item.Text);
    }
  });

  const dist = _.map(
    _.reject(positionKey, i => i === 'None'),
    (key) => {
      if (_.size(list[key]) > 0) {
        return _.first(list[key]);
      }
      return list.None.shift();
    }
  );

  return _.compact(dist);
}

export function getTitlePreview(headlines) {
  return getPreviewList(headlines, headlinePositionKey).join(' | ');
}

export function getDescPreview(descriptions) {
  return combineDescriptionArray(getPreviewList(descriptions, descriptionPositionKey));
}

function getMoreHint(assets, property, i18n) {
  const list = getPreviewList(assets, property === 'Headlines' ? headlinePositionKey : descriptionPositionKey);
  return assets.length > list.length ?
    i18n.getString('RSA_Count_More').replace('{{count}}', assets.length - list.length) : '';
}

export function getMoreTitleHint(headlines, i18n) {
  return getMoreHint(headlines, 'Headlines', i18n);
}

export function getMoreDescHint(descriptions, i18n) {
  return getMoreHint(descriptions, 'Descriptions', i18n);
}

function getMoreHintFromJson(jsonString, property, i18n) {
  let values = parseSync(jsonString);
  if (!_.isEmpty(values)) {
    values = _.map(values, value => parseSync(value));
    return getMoreHint(values, property, i18n);
  }
  return '';
}

export function getMoreTitleHintFromJson(jsonString, i18n) {
  return getMoreHintFromJson(jsonString, 'Headlines', i18n);
}

export function getMoreDescHintFromJson(jsonString, i18n) {
  return getMoreHintFromJson(jsonString, 'Descriptions', i18n);
}

function getPreviewFromJson(jsonString, property) {
  let values = parseSync(jsonString);
  let preview;

  if (!_.isEmpty(values)) {
    values = _.map(values, value => parseSync(value));
    preview = (property === 'Headlines') ? getTitlePreview(values) : getDescPreview(values);
  } else {
    preview = jsonString;
  }

  return preview;
}

export function getTitlePreviewFromJson(headlineValue) {
  return getPreviewFromJson(headlineValue, 'Headlines');
}

export function getDescPreviewFromJson(descriptionValue) {
  return getPreviewFromJson(descriptionValue, 'Descriptions');
}
